export const CLOSING_INFORMATION_SECTION_TITLE = 'Closing Information';

export const SPECIAL_ENDORSEMENT_LABEL = 'Special Endorsement';

export const SPECIAL_ENDORSEMENT_PENDING_KEY = 'specialEndorsement';
